import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ImportPreview } from 'tms-lib';
import { TmsWebBaseImportService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ImportSupplierProductInSupplerService extends TmsWebBaseImportService {
  constructor() {
    super('ImportSupplierProductInSupplier', 'Supplier Products');
  }

  exportSupplierProducts(supplierId: string): Observable<any> {
    return this.httpService
      .getForText(`${this.apiUrl}/ExportSupplierProducts?supplierId=${supplierId}`)
      .pipe(tap((data: string) => this.downloadExportFile(data, 'SupplierProducts')));
  }

  importSupplierProducts(file: any, id: string): Observable<any> {
    const formData = this.getFormData(file);
    return this.httpService.postForText(`${this.apiUrl}/ImportSupplierProducts/${id}`, formData);
  }

  previewSupplierProducts<T extends ImportPreview>(file: any, supplierId: string): Observable<T[]> {
    const formData = this.getFormData(file);
    return this.httpService.post<T[]>(`${this.apiUrl}/PreviewSupplierProducts/${supplierId}`, formData);
  }

  confirmImportSupplierProducts<T extends ImportPreview>(rows: T[], supplierId: string): Observable<any> {
    return this.httpService.postForText(`${this.apiUrl}/ImportSupplierProductsConfirmed/${supplierId}`, rows);
  }
}
